import type { Fact } from "./types";

export type FactState = "yes" | "no" | "unknown";

export function factState(
    fact: Fact,
    { noteCounts = false }: { noteCounts?: boolean } = {},
): FactState {
    if (fact.value === true) return "yes";
    if (fact.value === false) return "no";
    return noteCounts && fact.note ? "yes" : "unknown";
}
